import React from 'react'
// import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {
  PATH_CALL_TRACKING,
  PATH_CONTACTS,
  PATH_MAILING, PATH_NATURAL_REFERENCING, PATH_REPORT, PATH_REVIEWS, PATH_SUPPORT,
  PATH_WEB_FORMS, PATH_UPDATE_PLUGINS,
  ROOTS_DASHBOARD, PATH_CONVERSION_CLICK,
} from '../../../../app/routing/paths'
import {UserInterface} from '../../../../app/modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {ProductsKeys} from '../../../../global'
import {VerifyDateCondition} from '../../../../app/features'

export function AsideMenuMain() {

  // const intl = useIntl()
  const {
    googleAnalytics,
  }: UserInterface = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserInterface

  const {
    callTracking: callTrackingStore,
    webForms: webFormsStore,
    mailing: mailingStore,
    reviews: reviewsStore,
    statistics: statisticsStore,
    sav: savStore,
    updatePlugins: updatePluginsStore,
    contacts: contactsStore,
    conversionClicks: conversionClicksStore
  } = useSelector((state: RootState) => state.products)

  const paths: {active: boolean, key: ProductsKeys, to: string, title: string, icon: string}[] = [
    {
      active: VerifyDateCondition(callTrackingStore.encrypted, callTrackingStore.activated_at),
      key: 'Calltraking',
      to: PATH_CALL_TRACKING.root,
      title: 'Journal des appels',
      icon: 'communication/com014',
    },
    {
      active: VerifyDateCondition(webFormsStore.encrypted, webFormsStore.activated_at),
      key: 'Webformulaires',
      to: PATH_WEB_FORMS.root,
      title: 'Vos formulaires',
      icon: 'general/gen005',
    },
    {
      active: VerifyDateCondition(mailingStore.encrypted, mailingStore.activated_at),
      key: 'Mailing',
      to: PATH_MAILING.root,
      title: 'Vos campagnes e-mails',
      icon: 'communication/com002',
    },
    {
      active: VerifyDateCondition(statisticsStore.encrypted, statisticsStore.activated_at),
      key: 'Statistiques',
      to: PATH_NATURAL_REFERENCING.root,
      title: 'Référencement Naturel',
      icon: 'general/gen032',
    },
    {
      active: VerifyDateCondition(savStore.encrypted, savStore.activated_at),
      key: 'Sav', to: PATH_SUPPORT.root,
      title: 'Support',
      icon: 'coding/cod001',
    },
    {
      active: VerifyDateCondition(updatePluginsStore.encrypted, updatePluginsStore.activated_at),
      key: 'UpdatePlugins',
      to: PATH_UPDATE_PLUGINS.root,
      title: 'Mises à jour du site web',
      icon: 'arrows/arr031',
    },
    {
      active: VerifyDateCondition(reviewsStore.encrypted, reviewsStore.activated_at),
      key: 'Reviews',
      to: PATH_REVIEWS.root,
      title: 'Mes avis Google',
      icon: 'social/soc011',
    },
    {
      active: VerifyDateCondition(conversionClicksStore.encrypted, conversionClicksStore.activated_at),
      key: 'ConversionClicks',
      to: PATH_CONVERSION_CLICK.root,
      title: 'Conversion clics',
      icon: 'coding/cod006',
    },
  ]

  return (
    <>
      <AsideMenuItem to={ROOTS_DASHBOARD}
                     icon="/media/icons/duotune/art/art002.svg"
                     title="Tableau de bord"
                     fontIcon="bi-app-indicator"
      />

      {
        paths
          .filter(({active}) => active)
          .map(({to, icon, title, key}, index) => (
            key === 'Mailing' ? (
              <AsideMenuItemWithSub key={index}
                                    to={to}
                                    title="Vos campagnes e-mails"
                                    fontIcon="bi-sticky"
                                    icon="/media/icons/duotune/communication/com002.svg"
              >
                <AsideMenuItem to={PATH_MAILING.home} title="Accueil" hasBullet={true} />
                <AsideMenuItem to={PATH_MAILING.campaigns.root} title="Campagnes" hasBullet={true} />
                <AsideMenuItem to={PATH_MAILING.contacts.root} title="Contacts" hasBullet={true} />
                <AsideMenuItem to={PATH_MAILING.newCampaign.root} title="New Campaign" hasBullet={true} />
              </AsideMenuItemWithSub>
            ) : (
              <AsideMenuItem key={index}
                             to={to}
                             icon={`/media/icons/duotune/${icon}.svg`}
                             title={title}
                             fontIcon={'bi-layers'}
              />
            )
          ))
      }


      {/* Report */}
      {
        VerifyDateCondition(statisticsStore.encrypted, statisticsStore.activated_at) && googleAnalytics && (
          <AsideMenuItem to={PATH_REPORT.root}
                         title="Rapport"
                         fontIcon="bi-layers"
                         icon="/media/icons/duotune/general/gen062.svg"
          />
        )
      }

      {/* Contacts */}
      <AsideMenuItem to={PATH_CONTACTS.root}
                     title="Contacts"
                     fontIcon="bi-layers"
                     icon="/media/icons/duotune/communication/com013.svg"
      />

    </>
  )
}
